import {formatDateOrEmpty} from 'utils/func/justUtils'
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation'
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow'
import {
  Backdrop,
  Button,
  Chip,
  CircularProgress,
  Fade,
  FormControl,
  IconButton,
  InputAdornment,
  MenuItem,
  Modal,
  Select,
  Slider,
  TextField,
} from '@mui/material'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import {envBackHost, envImagePath, serverLocalName} from 'GLOBAL/envVariables'
import {isMobileDevice} from '_metronic/assets/ts/_utils'
import {yMarker} from 'assets/imageDeclear'
import {fabric} from 'fabric'
import {axiosWithAuth} from 'helper/axiosWithAuth'
import {useEffect, useRef, useState} from 'react'
import {useDaumPostcodePopup} from 'react-daum-postcode'
import {
  confirmAlert,
  noFotaAlert,
  normalAlert,
  noTextAlert,
  resultAlert,
  SuccessAlert,
} from 'utils/CustomAlert/Alert'
import {CustomWidthTooltip} from 'utils/designSytem/CustomTooltip'
import './imageEdit.css'
import './print.css'

import {Help as HelpIcon} from '@mui/icons-material'
import {useSelector} from 'react-redux'
import {
  globalSerialNumberFormatWithHyphens,
  meterReadEnum,
  serverList,
} from 'utils/const/globalConst'
import {showBusanInfoHandler} from 'utils/const/globalController'
import {DeviceEditImageTooltip} from 'utils/toolTips/toolTipText'
import useMobileBackClose from 'utils/hooks/useMobileBackClose'
import {runOpenCvFilter, scheduleOpenCvFilterWarmUp} from 'utils/opencvFilter'

/*********************************************************************
 * 1. Init Libs (all)
 *********************************************************************/

declare global {
  interface Window {
    kakao: any
  }
}
const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: !isMobileDevice() ? '95%' : '90%',
  height: !isMobileDevice() ? '90%' : '90%',
  bgcolor: 'background.paper',
  overflowY: 'auto',
  // border: '2px solid #000',
  borderRadius: '12px',
  boxShadow: 24,
  p: !isMobileDevice() ? 4 : 2,
}
const DeviceDetailInfoModal = (props: any) => {
  const addressInit = {
    latitude: '',
    longitude: '',
  }

  const imageFilterInit = {
    blur: 0,
    sharpening: 0,
    contrast: 1,
    brightness: 1,
    gamma: 1,
  }

  const fotaInit = {
    lwm2mIp: '',
    lwm2mPort: '',
    imageIpPort: '',
    firmwareVersion: '',
  }

  const overLayLineInit = {
    lineColor: '#000000',
    lineWidth: 3,
  }

  const revisionHandler = (serverName: any) => {
    switch (serverName) {
      case 'dev':
      case 'suncheon':
        return true
      default:
        return false
    }
  }

  /*********************************************************************
   * 2-1. useState (detail)
   *********************************************************************/
  const {data, open, onClose, getList} = props
  useMobileBackClose(open, onClose)
  const rotationRadian = (data?.rotate * Math.PI) / 180
  const cropperRef = useRef<any>(null)
  const [canvas, setCanvas] = useState<any | null>(null)
  const canvasRef = useRef(null)
  const [updateEfosImageInfo, setUpdateEfosImageInfo] = useState<any>(null)
  const [updateEfosInfo, setUpdateEfosInfo] = useState<any>(null)
  const [updateServerCycle, setUpdateServerCycle] = useState<number>(0)
  const [updateRecognizedType, setUpdateRecognizedType] = useState<any>(null)
  const [imageLoaded, setImageLoaded] = useState(false)
  const officeInfo = useSelector((state: any) => state?.officeInfo)
  const [doFota, setDoFota] = useState<boolean>(false)
  const [fotaData, setFotaData] = useState(fotaInit)
  const [address, setAddress] = useState<any>(addressInit)
  const CURRENT_URL = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js'

  /*********************************************************************
   * 3-1. handler (detail)
   *********************************************************************/
  /**
   * 지도 클릭시 다음 웹페이지
   */
  const openMap = useDaumPostcodePopup(CURRENT_URL)

  /**
   *
   * 위 경도 저장 하는 api
   */
  const handleComplete = async (datas: any) => {
    const location = await getAddressCoordinates(datas.roadAddress)

    console.log('location', location)
    if (location) {
      axiosWithAuth()
        .put(`${envBackHost}/deviceinfo/geolocate`, {
          imei: data.imei,
          latitude: location.y,
          longitude: location.x,
        })
        .then(async (res) => {
          await resultAlert(res.data)
          if (res.data.resultCode === 0) {
            getList()
            setAddress({
              latitude: location.y,
              longitude: location.x,
            })
          }
        })
        .catch(async (e) => {
          await resultAlert({resultCode: e.response.status})
        })
    } else {
      await noTextAlert('위도, 경도 확인이 불가합니다. 주소를 확인해주세요.')
    }
  }

  /**
   * 주소 검색시 수용가 주소 입력
   */
  const onClickHandler = () => {
    openMap({onComplete: handleComplete, defaultQuery: data?.addressRoad})
  }

  /**
   * 다음 주소 검색으로 나온 주소로 위 경도 찾기
   */
  const getAddressCoordinates = async (address: any) => {
    /* REST API(dapi) 직접 호출은 키의 IP 접근 제한에 걸려 브라우저에서 쓸 수 없다.
       지도와 동일한 JavaScript 키를 쓰는 services 라이브러리의 Geocoder 로 대체한다. */
    const geocoder = (window as any).kakao?.maps?.services
      ? new (window as any).kakao.maps.services.Geocoder()
      : null

    if (!geocoder) {
      console.error('Error fetching coordinates: kakao maps services not loaded')
      return null
    }

    return new Promise<{x: string; y: string} | null>((resolve) => {
      geocoder.addressSearch(
        address,
        (result: any[], status: any) => {
          if (status === (window as any).kakao.maps.services.Status.OK && result.length > 0) {
            resolve({x: result[0].x, y: result[0].y})
          } else {
            console.error('Error fetching coordinates:', status)
            resolve(null)
          }
        },
        {analyze_type: 'similar'}
      )
    })
  }

  /**
   * 서버 주기 업데이트
   */
  const updateServerCycleHandler = async () => {
    if (Number(updateServerCycle) === 0) {
      await normalAlert('서버 주기는 0이면 안됩니다.')
      return
    }
    if (updateServerCycle === data.serverCycle) {
      await normalAlert('변경 사항이 없습니다.')
      return
    }

    if (await confirmAlert('수정', 'info')) {
      axiosWithAuth()
        .put(`${envBackHost}/deviceinfo`, {
          imei: data.imei,
          latitude: data.latitude,
          longitude: data.longitude,
          temperature: data.temperature,
          serverCycle: updateServerCycle,
        })
        .then(async (res) => {
          await resultAlert(res.data)
          if (res.data.resultCode === 0) {
            getList()
          }
        })
        .catch(async (e) => {
          await resultAlert({resultCode: e.response.status})
        })
    } else {
      return
    }
  }
  /**
   * 아마도 명암 밝기 수정
   */
  const updateEfosInfoHandler = async (type: string) => {
    if (updateEfosInfo === null) {
      await normalAlert('변경된 데이터가 없습니다.')
      return
    }
    if (await confirmAlert('수정', 'info')) {
      const requestData = {[type]: updateEfosInfo[type], imei: data.imei}
      axiosWithAuth()
        .put(`${envBackHost}/efosinfo/${type}`, requestData)
        .then(async (res) => {
          await resultAlert(res.data)
          if (res.data.resultCode === 0) {
            getList()
          }
        })
        .catch(async (e) => {
          await resultAlert({resultCode: e.response.status})
        })
    }
  }
  /**
   * 지침부 자리 바꾸기..?
   */
  const updateEfosImageHandler = async () => {
    if (await confirmAlert('수정', 'info')) {
      axiosWithAuth()
        .put(`${envBackHost}/efosimage`, updateEfosImageInfo)
        .then(async (res) => {
          await resultAlert(res.data)
          if (res.data.resultCode === 0) {
            await getList()
          }
        })
        .catch(async (e) => {
          await resultAlert({resultCode: e.response.status})
        })
    }
  }
  /**
   * 계량기 타입 바꾸기
   */
  const updateRecognizedTypeHandler = async () => {
    axiosWithAuth()
      .put(`${envBackHost}/deviceinfo/recognizedtype`, {
        imei: data.imei,
        latitude: data.latitude,
        longitude: data.longitude,
        recognizedType: updateRecognizedType,
      })
      .then(async (res) => {
        await resultAlert(res.data)
        if (res.data.resultCode === 0) {
          getList()
        }
      })
      .catch(async (e) => {
        await resultAlert({resultCode: e.response.status})
      })
  }

  /**
   * lw2m2 서버 바꾸는
   */

  const selectServerHandler = (serverId: any) => {
    const selected = serverList.find((server) => server.id === serverId)
    if (!selected) return

    setFotaData({
      lwm2mIp: selected.lwm2mIp,
      lwm2mPort: selected.lwm2mPort,
      imageIpPort: selected.imageIpPort,
      firmwareVersion: selected.firmwareVersion,
    })
  }

  /**
   * lwm2m
   */
  const updateLwm2mInfo = async () => {
    // 서버를 고르지 않은 채로 보내면 빈 값으로 단말기 설정을 덮어쓴다.
    if (!fotaData?.lwm2mIp || !fotaData?.lwm2mPort || !fotaData?.imageIpPort) {
      return await normalAlert('변경할 서버를 선택해주세요.')
    }
    axiosWithAuth()
      .patch(`${envBackHost}/device/${data?.imei}/ip`, fotaData)
      .then(async (res) => {
        await resultAlert(res.data)
        if (res.data.resultCode === 0) {
          getList()
        }
      })
      .catch(async (e) => {
        await resultAlert({resultCode: e.response.status})
      })
  }

  const lwm2mFotaHandler = async (data: any) => {
    if (!doFota) {
      if (!fotaHandler(data)) {
        return noFotaAlert()
      }

      setDoFota(true)
    } else {
      setDoFota(false)
      updateLwm2mInfo()
    }
  }

  /**
   * 단말기에 설정된 주소로 서버를 찾는다.
   * lwm2mIp 만 보면 그 값이 비어 있는 단말기는 서버를 못 찾으므로
   * 이미지 서버 주소로도 한 번 더 맞춰본다.
   */
  const selectedServerId =
    serverList.find((server) => {
      const lwm2mIp = (fotaData?.lwm2mIp || data?.lwm2mIp || '').toString().trim()
      const imageIpPort = (fotaData?.imageIpPort || data?.imageIpPort || '').toString().trim()
      return (
        (!!lwm2mIp && server.lwm2mIp === lwm2mIp) ||
        (!!imageIpPort && server.imageIpPort === imageIpPort)
      )
    })?.id ?? ''

  /**
   * FOTA 가능 여부. 값이 아예 없는 경우(undefined, 빈 문자열)도 불가로 본다.
   * null 만 걸러내면 목록에 그 필드가 없는 화면에서 항상 가능으로 잡힌다.
   */
  const fotaHandler = (target: any) => Boolean(target?.firmwareVersion && target?.lwm2mIp)

  /**
   * esc , x 표시로 닫을때
   */
  const closeHandler = () => {
    onClose()
    getList()
    setAddress(addressInit)
    setUpdateRecognizedType(null)
    setImageLoaded(false)
    setDoFota(false)
    setFotaData(fotaInit)
    cropperRef.current?.cropper.destroy()
    setSelectedView('detail')
    setImageFilter(imageFilterInit)
    resetOverLayFilter()
    setLoadedImage(null)
    setSelectedCVImage(null)
    setOverLayImagePath(null)
  }

  /**
   * 얘는 왜 따로 나와있지 (빨간 영역 박스)
   */
  canvas?.on('object:modified', (e: any) => {
    const activeObject = e.target
    const rect = activeObject
    const boundingBox = rect.getBoundingRect()
    const imageObject = canvas.getObjects().find((obj: any) => obj.type === 'image')
    const xstart = boundingBox.left
    const ystart = boundingBox.top
    const xend = boundingBox.left + boundingBox.width
    const yend = boundingBox.top + boundingBox.height
    const rotate = imageObject?.angle

    setUpdateEfosImageInfo({
      imei: data?.imei,
      xstart,
      ystart,
      xend,
      yend,
      rotate,
    })
  })

  /*********************************************************************
   * 2-1. useState (edit)
   *********************************************************************/
  const [selectedView, setSelectedView] = useState<string>('detail')
  const baseCanvasRef = useRef<HTMLCanvasElement | null>(null) // 원본
  const overlayCanvasRef = useRef<HTMLCanvasElement | null>(null) // 오버레이
  const openCVCanvasRef = useRef<HTMLCanvasElement | null>(null) //opencv
  const resultCanvasRef = useRef<HTMLCanvasElement | null>(null) //최종 이미지
  const [isDrawing, setIsDrawing] = useState(false)
  const [isRectangleMode, setIsRectangleMode] = useState(false) // 사각형 모드
  const [startPoint, setStartPoint] = useState<{x: number; y: number} | null>(null)
  const [overLayImagePath, setOverLayImagePath] = useState<any>(null)
  const [overLayLine, setOverLayLine] = useState<any>(overLayLineInit) // line setting
  const [loadedImage, setLoadedImage] = useState<HTMLImageElement | null>(null) //베이스 이미지
  const [imageFilter, setImageFilter] = useState<any>(imageFilterInit) // image filter
  const [selectedCVImage, setSelectedCVImage] = useState<HTMLImageElement | null>(null)
  /* ref 로 두면 값이 바뀌어도 리렌더가 안 일어나 필터 적용 effect 가 다시 돌지 않는다 */
  const [cvReady, setCvReady] = useState<boolean>(false)
  /* 워커 응답이 순서대로 오지 않을 수 있어, 마지막으로 보낸 요청만 그린다 */
  const filterSeq = useRef<number>(0)
  /* 워커가 실패하면 보정이 안 걸린 원본이 그대로 보인다. 그걸 보정된 이미지로
     오해하면 잘못된 값을 저장하게 되므로, 조용히 넘기지 않고 화면에 알린다 */
  const [cvFailed, setCvFailed] = useState<boolean>(false)

  /*********************************************************************
   * 3-1. handler (edit)
   *********************************************************************/
  /** 비동기 이미지 로드 함수 */

  const getImageRevisionData = async () => {
    axiosWithAuth()
      .get(`${envBackHost}/device/imagerevision/${data?.imei}`)
      .then(async (res) => {
        const data = res.data.res
        if (data) {
          setOverLayImagePath(data?.revisionPath)
          setImageFilter({
            ...imageFilter,
            blur: data?.blur,
            sharpening: data?.sharpening,
            contrast: data?.contrast,
            brightness: data?.brightness,
            gamma: data?.gamma,
          })
        }
      })
      .catch(async (e) => {
        console.log('err', e)
      })
  }

  const deleteImageRevisionData = async () => {
    if (data?.revisionPath === null) {
      normalAlert('보정된 이미지가 없습니다')
      return
    }

    axiosWithAuth()
      .delete(`${envBackHost}/device/imagerevision/${data?.imei}`)
      .then(async (res) => {
        const data = res.data

        if (data) {
          resultAlert(data)
          setOverLayImagePath(null)
          setImageFilter(imageFilterInit)
          clearCanvas()
        }
      })
  }

  const postImageRevisionData = async (imageFilter: any) => {
    const overlayCanvas = overlayCanvasRef.current

    if (!overlayCanvas) return
    // canvas 데이터를 Blob으로 변환
    // 회전 값을 원래대로 복원하기 위한 새 canvas 생성
    const tempCanvas = document.createElement('canvas')
    const tempCtx = tempCanvas.getContext('2d')
    if (!tempCtx) return

    tempCanvas.width = overlayCanvas.width
    tempCanvas.height = overlayCanvas.height
    tempCtx.save()
    tempCtx.translate(tempCanvas.width / 2, tempCanvas.height / 2)
    tempCtx.rotate(-rotationRadian) // 회전값을 원래대로 복원
    tempCtx.translate(-tempCanvas.width / 2, -tempCanvas.height / 2)
    tempCtx.drawImage(overlayCanvas, 0, 0, overlayCanvas.width, overlayCanvas.height)
    tempCtx.restore()

    tempCanvas.toBlob(async (blob) => {
      if (!blob) return

      const formData = new FormData()
      formData.append('image', blob, 'overlayImage.png')
      formData.append(
        'imageRevisionModel',
        new Blob([JSON.stringify({...imageFilter, imei: data?.imei})], {type: 'application/json'})
      )

      try {
        const res = await axiosWithAuth().post(`${envBackHost}/device/imagerevision`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        if (res.data) {
          SuccessAlert('레이어를 저장하였습니다.')
          getList()
        }
      } catch (e) {
        console.log('err', e)
      }
    }, 'image/png')
  }

  const drawRectangle = (
    startX: number,
    startY: number,
    endX: number,
    endY: number,
    overlayCtx: CanvasRenderingContext2D,
    baseCtx: CanvasRenderingContext2D
  ) => {
    const rectWidth = endX - startX
    const rectHeight = endY - startY

    // 오버레이 캔버스에 사각형 그리기
    overlayCtx.beginPath()
    overlayCtx.fillStyle = overLayLine.lineColor
    overlayCtx.fillRect(startX, startY, rectWidth, rectHeight)
    overlayCtx.strokeStyle = overLayLine.lineColor
    overlayCtx.lineWidth = overLayLine.lineWidth
    overlayCtx.strokeRect(startX, startY, rectWidth, rectHeight)
    overlayCtx.closePath()

    // 원본 캔버스에 사각형 그리기
    baseCtx.beginPath()
    baseCtx.fillStyle = overLayLine.lineColor
    baseCtx.fillRect(startX, startY, rectWidth, rectHeight)
    baseCtx.strokeStyle = overLayLine.lineColor
    baseCtx.lineWidth = overLayLine.lineWidth
    baseCtx.strokeRect(startX, startY, rectWidth, rectHeight)
    baseCtx.closePath()
  }

  /**
   * 그림판 기능 그릴때 클릭지점 구하기
   */
  const draw = (event: React.MouseEvent<HTMLCanvasElement>) => {
    if (!isDrawing || !overlayCanvasRef.current || !baseCanvasRef.current) return

    const overlayCanvas = overlayCanvasRef.current
    const baseCanvas = baseCanvasRef.current

    const overlayCtx = overlayCanvas.getContext('2d')
    const baseCtx = baseCanvas.getContext('2d')

    if (!overlayCtx || !baseCtx) return

    const rect = overlayCanvas.getBoundingClientRect()
    const scaleX = overlayCanvas.width / rect.width
    const scaleY = overlayCanvas.height / rect.height

    const x = event.nativeEvent.offsetX * scaleX
    const y = event.nativeEvent.offsetY * scaleY

    if (isRectangleMode && startPoint) {
      const {x: startX, y: startY} = startPoint

      baseCtx.clearRect(0, 0, baseCanvas.width, baseCanvas.height)

      if (baseCanvas && baseCtx && loadedImage) {
        baseCanvas.width = loadedImage.width
        baseCanvas.height = loadedImage.height
        drawRotatedImage(baseCanvas, baseCtx, loadedImage, rotationRadian)
        baseCtx.drawImage(overlayCanvas, 0, 0, overlayCanvas.width, overlayCanvas.height)
      }

      baseCtx.beginPath()
      baseCtx.strokeStyle = overLayLine.lineColor
      baseCtx.lineWidth = overLayLine.lineWidth
      baseCtx.strokeRect(startX, startY, x - startX, y - startY)
      baseCtx.closePath()
    } else {
      // 기존 선 그리기 모드
      overlayCtx.strokeStyle = overLayLine.lineColor
      overlayCtx.lineWidth = overLayLine.lineWidth
      overlayCtx.lineCap = 'round'
      overlayCtx.lineTo(x, y)
      overlayCtx.stroke()

      baseCtx.strokeStyle = overLayLine.lineColor
      baseCtx.lineWidth = overLayLine.lineWidth
      baseCtx.lineCap = 'round'
      baseCtx.lineTo(x, y)
      baseCtx.stroke()
    }
  }
  /**
   * 그림판 기능 그리는중
   */
  const startDrawing = (event: React.MouseEvent<HTMLCanvasElement>) => {
    const overlayCanvas = overlayCanvasRef.current
    const baseCanvas = baseCanvasRef.current
    if (!overlayCanvas || !baseCanvas) return

    const overlayCtx = overlayCanvas.getContext('2d')
    const baseCtx = baseCanvas.getContext('2d')
    if (!overlayCtx || !baseCtx) return

    // 캔버스와 이미지의 비율 계산
    const rect = overlayCanvas.getBoundingClientRect()
    const scaleX = overlayCanvas.width / rect.width
    const scaleY = overlayCanvas.height / rect.height

    // 실제 좌표 계산
    const x = event.nativeEvent.offsetX * scaleX
    const y = event.nativeEvent.offsetY * scaleY

    if (isRectangleMode) {
      setStartPoint({x, y})
    } else {
      overlayCtx.beginPath()
      overlayCtx.moveTo(x, y)
      baseCtx.beginPath()
      baseCtx.moveTo(x, y)
    }

    setIsDrawing(true)
  }

  /**
   * 그림판 기능 그리기 끝났을때 (마우스 unclick)
   */
  const stopDrawing = (event: React.MouseEvent<HTMLCanvasElement>) => {
    setIsDrawing(false)

    const overlayCanvas = overlayCanvasRef.current
    const baseCanvas = baseCanvasRef.current
    if (!overlayCanvas || !baseCanvas) return

    const overlayCtx = overlayCanvas.getContext('2d')
    const baseCtx = baseCanvas.getContext('2d')
    if (!overlayCtx || !baseCtx) return

    overlayCtx.closePath()
    baseCtx.closePath()

    if (isRectangleMode && startPoint) {
      const rect = overlayCanvas.getBoundingClientRect()
      const scaleX = overlayCanvas.width / rect.width
      const scaleY = overlayCanvas.height / rect.height
      const endX = event.nativeEvent.offsetX * scaleX
      const endY = event.nativeEvent.offsetY * scaleY
      const {x: startX, y: startY} = startPoint

      drawRectangle(startX, startY, endX, endY, overlayCtx, baseCtx)
      setStartPoint(null)
    }
  }

  const clearCanvas = () => {
    const overlayCanvas = overlayCanvasRef.current
    const baseCanvas = baseCanvasRef.current
    if (!overlayCanvas || !baseCanvas) return

    const overlayCtx = overlayCanvas.getContext('2d')
    const baseCtx = baseCanvas.getContext('2d')
    if (!overlayCtx || !baseCtx) return

    // 캔버스 초기화
    overlayCtx.clearRect(0, 0, overlayCanvas.width, overlayCanvas.height)
    baseCtx.clearRect(0, 0, baseCanvas.width, baseCanvas.height)

    if (loadedImage) {
      if (loadedImage.width > 0 && loadedImage.height > 0) {
        drawRotatedImage(baseCanvas, baseCtx, loadedImage, rotationRadian)
      } else {
        console.error('Invalid loaded image dimensions.')
      }
    }

    combineLayers()
  }

  const clearCanvasHandler = async () => {
    clearCanvas()
  }

  /**
   * 레이어 및 필터 설정 DB 저장
   */
  const saveFilterSetting = async () => {
    postImageRevisionData(imageFilter)
  }

  /**
   * openCV 필터 워커 준비
   *
   * 이미지 필터에만 쓰는 7.9MB 라이브러리라 index.html 에서 받지 않는다.
   * (yarn add opencv.js 이후 cp node_modules/opencv.js/opencv.js public/js/ 로 옮겨둔 정적 파일)
   *
   * 다운로드와 WASM 컴파일을 워커가 맡으므로 그동안 화면은 멈추지 않는다. 이 모달은 목록
   * 화면에 상시 마운트돼 있어서, 마운트 시점에 띄워두면 모달을 열 때는 이미 준비가 끝나 있다.
   */
  useEffect(
    () =>
      scheduleOpenCvFilterWarmUp(
        () => setCvReady(true),
        (err) => {
          console.error('OpenCV 필터 워커 준비 실패:', err)
          setCvFailed(true)
        }
      ),
    []
  )
  /**
   * 필터 초기화
   */
  const changeImageFilter = (name: string, value: any) => {
    setImageFilter({...imageFilter, [name]: value})
  }
  /**
   * 필터 기능 입히기
   */
  const applyImageEffects = async (img: HTMLImageElement) => {
    if (!cvReady || !openCVCanvasRef.current || !img) {
      return
    }

    const canvas = openCVCanvasRef.current
    const ctx = canvas.getContext('2d')
    if (!ctx) {
      console.error('Canvas context not found')
      return
    }
    canvas.width = img.width
    canvas.height = img.height
    drawRotatedImage(canvas, ctx, img, rotationRadian)

    /* 슬라이더를 연속으로 움직이면 요청이 겹친다. 늦게 도착한 옛 결과가 최신 결과를
       덮어쓰지 않도록 순번을 매겨 마지막 것만 그린다. */
    const seq = ++filterSeq.current

    let source: ImageData
    try {
      source = ctx.getImageData(0, 0, canvas.width, canvas.height)
    } catch (err) {
      /* 다른 출처 이미지를 그린 캔버스는 읽을 수 없다 (CORS) */
      console.error('캔버스를 읽지 못했습니다:', err)
      return
    }

    try {
      const filtered = await runOpenCvFilter(source, imageFilter)
      if (seq !== filterSeq.current) return
      ctx.putImageData(filtered, 0, 0)
      combineLayers()
    } catch (err) {
      console.error('필터 적용 실패:', err)
      setCvFailed(true)
    }
  }

  const resetImageFilter = async () => {
    setImageFilter(imageFilterInit)
    if (selectedCVImage) {
      applyImageEffects(selectedCVImage)
    }
  }

  const combineLayers = () => {
    const resultCanvas = resultCanvasRef.current
    const filterCanvas = openCVCanvasRef.current
    const overlayCanvas = overlayCanvasRef.current

    if (!resultCanvas || !filterCanvas || !overlayCanvas) {
      console.error('캔버스가 준비되지 않았습니다.')
      return
    }

    if (
      filterCanvas.width > 0 &&
      filterCanvas.height > 0 &&
      overlayCanvas.width > 0 &&
      overlayCanvas.height > 0
    ) {
      const resultCtx = resultCanvas.getContext('2d')
      const filterCtx = filterCanvas.getContext('2d')
      const overlayCtx = overlayCanvas.getContext('2d')

      if (!resultCtx || !filterCtx || !overlayCtx) {
        console.error('캔버스 컨텍스트를 가져오지 못했습니다.')
        return
      }

      resultCanvas.width = filterCanvas.width
      resultCanvas.height = filterCanvas.height
      resultCtx.clearRect(0, 0, resultCanvas.width, resultCanvas.height)

      resultCtx.drawImage(filterCanvas, 0, 0)

      resultCtx.globalAlpha = 1
      resultCtx.drawImage(overlayCanvas, 0, 0)
    } else {
      console.error('Invalid dimensions in one or more canvases.')
    }
  }

  const drawRotatedImage = (
    canvas: any,
    ctx: CanvasRenderingContext2D,
    image: any,
    rotationRadian: any
  ) => {
    ctx.save()
    ctx.translate(canvas.width / 2, canvas.height / 2)
    ctx.rotate(rotationRadian)

    if (!image.complete || image.naturalWidth === 0 || image.naturalHeight === 0) {
      console.error('이미지가 올바르게 로드되지 않았습니다.')
      return
    }
    ctx.drawImage(image, -image.width / 2, -image.height / 2, image.width, image.height)
    ctx.restore()
  }

  const resetOverLayFilter = () => {
    setOverLayLine(overLayLineInit)
    combineLayers()
  }

  const changeOverLayLineHandler = (name: string, value: any) => {
    setOverLayLine({...overLayLine, [name]: value})
  }

  /*********************************************************************
   * 5. UseEffect
   *********************************************************************/

  /**
   * 검침 이미지 보정 탭 이미지들 캔버스에 load 및 표현
   * croossOrigin 설정으로 http 환경, CORS 에러 방지
   */
  useEffect(() => {
    const imageURL = envImagePath + (data?.filePath || '')
    if (!data?.filePath) return

    let overLayURL = data?.revisionPath
      ? `${envImagePath}/device/imagerevision/${data.imei}/image`
      : ''

    const img = new Image()
    img.src = imageURL
    img.crossOrigin = 'anonymous'

    const overLayimg = new Image()
    overLayimg.crossOrigin = 'anonymous'
    if (overLayURL && overLayURL !== '') {
      overLayimg.src = overLayURL

      // 이미지 로드 실패 시 처리
      overLayimg.onerror = () => {
        console.error(
          `Failed to load overlay image from URL: ${overLayURL}. Using placeholder image.`
        )
        overLayimg.src =
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAwAB/ibSUuoAAAAASUVORK5CYII='
      }
    } else {
      // 기본 이미지 설정
      overLayimg.src =
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAwAB/ibSUuoAAAAASUVORK5CYII='
    }

    img.onload = () => {
      setLoadedImage(img)
      setSelectedCVImage(img)
      const baseCanvas = baseCanvasRef.current
      const openCVCanvas = openCVCanvasRef.current
      if (!baseCanvas || !openCVCanvas) return

      const baseCtx = baseCanvas.getContext('2d')
      const openCVCtx = openCVCanvas.getContext('2d')

      if (!baseCtx || !openCVCtx) return

      baseCanvas.width = img.width
      baseCanvas.height = img.height
      openCVCanvas.width = img.width
      openCVCanvas.height = img.height

      const overlayCanvas = overlayCanvasRef.current
      if (!overlayCanvas) return
      const overlayCtx = overlayCanvas.getContext('2d')
      if (!overlayCtx) return

      overlayCanvas.width = img.width
      overlayCanvas.height = img.height

      drawRotatedImage(baseCanvas, baseCtx, img, rotationRadian)
      drawRotatedImage(overlayCanvas, overlayCtx, overLayimg, rotationRadian)
      drawRotatedImage(openCVCanvas, openCVCtx, img, rotationRadian)
    }

    img.onerror = (error) => {
      console.error('이미지 로드 실패:', error)
    }
  }, [data, selectedView])

  /**
   * 이미지에 필터 적용
   */
  useEffect(() => {
    if (cvReady && selectedCVImage) {
      applyImageEffects(selectedCVImage)
    }
  }, [imageFilter, selectedCVImage, cvReady])
  // useEffect(() => {}, [data])
  /**
   * detail 페이지 캔버스
   */
  useEffect(() => {
    setTimeout(() => {
      const canvasInstance = new fabric.Canvas('imageEdit', {
        width: 320,
        height: 144,
        padding: 5,
        top: 150,
      })
      setCanvas(canvasInstance)
      setUpdateServerCycle(data?.serverCycle)
      setUpdateEfosImageInfo({
        ...updateEfosImageInfo,
        imei: data?.imei,
        xstart: data?.xfrom,
        ystart: data?.yfrom,
        xend: data?.xto,
        yend: data?.yto,
        rotate: data?.rotate,
      })

      setFotaData({
        lwm2mIp: data?.lwm2mIp,
        lwm2mPort: data?.lwm2mPort,
        imageIpPort: data?.imageIpPort,
        firmwareVersion: data?.firmwareVersion,
      })

      return () => {
        canvasInstance.dispose()
      }
    }, 100)
  }, [data, selectedView, open])

  /**
   * detail 페이지 캔버스 2
   */
  useEffect(() => {
    console.log('worked')
    if (!canvas) return
    if (data) {
      const imageUrl = envImagePath + (data?.filePath || '')
      // const slice = data?.filePath?.split('/')
      fabric.Image.fromURL(imageUrl, (img: any) => {
        const imgWidth = img ? img.width : 320
        const imgHeight = img ? img.height : 144
        if (imgWidth > canvas.width || imgHeight > canvas.height) {
          canvas.setDimensions({width: imgWidth, height: imgHeight})
        }

        img.set({
          left: canvas.width / 2,
          top: canvas.height / 2,
          width: imgWidth,
          height: imgHeight,
          originX: 'center',
          originY: 'center',
          selectable: false,
          angle: data?.rotate,
        })
        canvas.add(img)

        const horizontalRect = new fabric.Rect({
          left: data?.xfrom !== 0 ? img.left + (data?.xfrom - imgWidth / 2) : 0,
          top: data?.yfrom !== 0 ? img.top + (data?.yfrom - imgHeight / 2) : 0,
          width: data?.xto !== 0 ? data?.xto - data?.xfrom : imgWidth - 3,
          height: data?.yto !== 0 ? data?.yto - data?.yfrom : imgHeight - 3,
          scaleX: 1,
          scaleY: 1,
          fill: 'transparent',
          stroke: 'red',
          strokeWidth: 2,
          selectable: true,
          rotatable: false,
          cornerColor: 'white',
          cornerSize: 15,
        })
        horizontalRect.setControlsVisibility({
          mt: true, // 중앙 위
          mb: true, // 중앙 아래
          ml: true, // 중앙 왼쪽
          mr: true, // 중앙 오른쪽
          bl: true, // 왼쪽 아래
          br: true, // 오른쪽 아래
          tl: true, // 왼쪽 위
          tr: true, // 오른쪽 위
          mtr: false, // 회전 포인트
        })

        canvas.add(horizontalRect)
        canvas.renderAll()
      })
    }
  }, [canvas, data, selectedView, open])

  /**
   * detail 지도 useEffect
   */

  useEffect(() => {
    const latitude = address?.latitude || data?.latitude
    const longitude = address?.longitude || data?.longitude

    if (latitude && longitude) {
      setTimeout(() => {
        let container = document?.getElementById('dashboard-detail-map')
        if (container) {
          const map = new window.kakao.maps.Map(container, {
            center: new window.kakao.maps.LatLng(latitude, longitude),
            mapTypeId: window.kakao.maps.MapTypeId.HYBRID,
            level: 1,
            draggable: false,
            scrollwheel: false,
            zoomable: false,
          })

          const markerPosition = new window.kakao.maps.LatLng(latitude, longitude)
          const marker = new window.kakao.maps.Marker({
            position: markerPosition,
            image: new window.kakao.maps.MarkerImage(yMarker, new window.kakao.maps.Size(40, 59)),
          })

          marker.setMap(map)
        }
      }, 300)
    }
  }, [data, address, selectedView, open])

  /*
   * 컴포넌트 마운트 후 및 필터 또는 레이어 변경 시 결합
   */
  useEffect(() => {
    if (loadedImage && openCVCanvasRef.current && overlayCanvasRef.current) {
      combineLayers()
    }
  }, [imageFilter, isDrawing, overlayCanvasRef, selectedView, loadedImage, open])

  useEffect(() => {
    if (revisionHandler(serverLocalName)) {
      getImageRevisionData()
    }
  }, [data, open])

  return (
    <Modal
      open={open}
      onClose={() => {
        closeHandler()
      }}
      aria-labelledby={`${window.location.pathname}-label`}
      aria-describedby={`${window.location.pathname}-description`}
      closeAfterTransition
      slots={{backdrop: Backdrop}}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
      id={'printTarget'}
      className={'printTarget'}
    >
      <Box sx={style}>
        <>
          <div>
            <div>
              <div className=''>
                <div className={'w-100 d-flex justify-content-between'}>
                  <div className={'d-flex'}>
                    <div
                      onClick={() => {
                        setSelectedView('detail')
                      }}
                    >
                      <Chip
                        label={
                          <span>
                            <strong className={'text-primary'}>{data?.customerName}</strong> 단말기
                            및 검침기 상세정보
                          </span>
                        }
                        variant={'outlined'}
                        sx={{
                          cursor: 'pointer',
                          fontSize: '20px',
                          fontWeight: 'bold',
                          backgroundColor:
                            selectedView === 'detail' ? 'rgba(0, 123, 255, 0.1)' : 'transparent',
                          borderColor:
                            selectedView === 'detail' ? '#007BFF' : 'rgba(0, 0, 0, 0.23)',
                          color: selectedView === 'detail' ? '#007BFF' : 'inherit',
                        }}
                      />
                    </div>
                    {revisionHandler(serverLocalName) && (
                      <div
                        onClick={() => {
                          setSelectedView('edit')
                        }}
                        className={'mx-2'}
                      >
                        <Chip
                          label={<span>검침 이미지 보정</span>}
                          variant={'outlined'}
                          sx={{
                            cursor: 'pointer',
                            fontSize: '20px',
                            fontWeight: 'bold',
                            backgroundColor:
                              selectedView === 'edit' ? 'rgba(0, 123, 255, 0.1)' : 'transparent',
                            borderColor:
                              selectedView === 'edit' ? '#007BFF' : 'rgba(0, 0, 0, 0.23)',
                            color: selectedView === 'edit' ? '#007BFF' : 'inherit',
                          }}
                        />
                      </div>
                    )}
                  </div>
                  <CancelPresentationIcon
                    sx={{fontSize: '40px', cursor: 'pointer'}}
                    color={'error'}
                    onClick={() => {
                      closeHandler()
                    }}
                  />
                </div>
                {selectedView === 'detail' && (
                  <div className=''>
                    {data && (
                      <>
                        <div className={'d-flex gap-6 col'}>
                          <div className={'col'}>
                            <div className={'row mx-0 gap-2'}>
                              <div
                                className={
                                  ' border border-1 border-gray-400 shadow-sm px-0 overflow-auto max-h-[80vh]'
                                }
                              >
                                <Paper
                                  className={'p-4 border-bottom border-1 border-gray-400 '}
                                  square
                                >
                                  <span className='font-semibold text-[1.25rem]'>단말기 정보</span>
                                </Paper>
                                <Paper className={'p-4 '} square>
                                  <div className={'row gap-2'}>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span
                                        className={
                                          'd-flex align-items-center gap-2 font-semibold text-[1.25rem]'
                                        }
                                      >
                                        <DoubleArrowIcon /> 단말기 IMEI
                                      </span>

                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={data?.imei}
                                        inputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span
                                        className={
                                          'd-flex align-items-center gap-2 font-semibold text-[1.25rem]'
                                        }
                                      >
                                        <DoubleArrowIcon /> 단말기 S/N
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={globalSerialNumberFormatWithHyphens(
                                          data?.serialNumber
                                        )}
                                        inputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span
                                        className={
                                          'd-flex align-items-center gap-2 font-semibold text-[1.25rem]'
                                        }
                                      >
                                        <DoubleArrowIcon /> 업데이트 대기
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={
                                          data.deviceApplyStatus === true
                                            ? '업데이트 대기 중'
                                            : '업데이트 없음'
                                        }
                                        inputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>

                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span
                                        className={
                                          'd-flex align-items-center gap-2 font-semibold text-[1.25rem]'
                                        }
                                      >
                                        <DoubleArrowIcon /> 단말기 타입
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={data?.deviceTypeName}
                                        inputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span
                                        className={
                                          'd-flex align-items-center gap-2 font-semibold text-[1.25rem]'
                                        }
                                      >
                                        <DoubleArrowIcon /> 펌웨어
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={data?.deviceVersion}
                                        inputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span
                                        className={
                                          'd-flex align-items-center gap-2 font-semibold text-[1.25rem]'
                                        }
                                      >
                                        <DoubleArrowIcon /> 단말기 통신상태
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={data?.deviceStatus === true ? '정상' : '점검'}
                                        inputProps={{
                                          readOnly: true,
                                        }}
                                        error={data?.deviceStatus === false}
                                      />
                                    </div>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span
                                        className={
                                          'd-flex align-items-center gap-2 font-semibold text-[1.25rem]'
                                        }
                                      >
                                        <DoubleArrowIcon /> 단말기 통신실패
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={data.deviceCommFailCount + '회'}
                                        inputProps={{
                                          readOnly: true,
                                        }}
                                        error={data?.deviceStatus === false}
                                      />
                                    </div>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span
                                        className={
                                          'd-flex align-items-center gap-2 font-semibold text-[1.25rem]'
                                        }
                                      >
                                        <DoubleArrowIcon /> 배터리
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={data?.batteryLevel + '%'}
                                        inputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span
                                        className={
                                          'd-flex align-items-center gap-2 font-semibold text-[1.25rem]'
                                        }
                                      >
                                        <DoubleArrowIcon /> 최초 설치일자
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={formatDateOrEmpty(
                                          data?.installAt,
                                          'YYYY년 M월 DD일'
                                        )}
                                        inputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span
                                        className={
                                          'd-flex align-items-center gap-2 font-semibold text-[1.25rem]'
                                        }
                                      >
                                        <DoubleArrowIcon /> 서버주기
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        style={{width: 319}}
                                        className={'mx-2 '}
                                        defaultValue={Number(data?.serverCycle)}
                                        type={'number'}
                                        onChange={(e: any) => {
                                          setUpdateServerCycle(e.target.value)
                                        }}
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position='end'>
                                              <IconButton aria-label='resetBtn' edge='end'>
                                                <Button
                                                  variant={'outlined'}
                                                  size={'large'}
                                                  sx={{width: 50, height: 50}}
                                                  onClick={() => updateServerCycleHandler()}
                                                  disabled={data?.deviceType === 'digital'}
                                                >
                                                  수정
                                                </Button>
                                              </IconButton>
                                            </InputAdornment>
                                          ),
                                        }}
                                      />
                                    </div>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <div className={'d-flex gap-3'}>
                                        <span
                                          className={
                                            'd-flex align-items-center gap-2 font-semibold text-[1.25rem]'
                                          }
                                        >
                                          <DoubleArrowIcon /> 위도
                                        </span>
                                        <Button
                                          variant={'outlined'}
                                          size={'large'}
                                          onClick={() => onClickHandler()}
                                        >
                                          위치수정
                                        </Button>
                                      </div>
                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={
                                          address.latitude === ''
                                            ? data?.latitude
                                            : address.latitude
                                        }
                                        inputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span
                                        className={
                                          'd-flex align-items-center gap-2 font-semibold text-[1.25rem]'
                                        }
                                      >
                                        <DoubleArrowIcon /> 경도
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={
                                          address.longitude === ''
                                            ? data?.longitude
                                            : address.longitude
                                        }
                                        inputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                  </div>
                                </Paper>
                                <Paper className={'p-4 '} square>
                                  <div className={'row gap-2 justify-center'}>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <div className='flex gap-2'>
                                        <span
                                          className={
                                            'd-flex align-items-center gap-2 font-semibold text-[1.25rem]'
                                          }
                                        >
                                          <DoubleArrowIcon /> lwm2m 서버
                                        </span>
                                        <Button
                                          variant='outlined'
                                          size='small'
                                          sx={{
                                            padding: '4px 8px',
                                            fontSize: '1rem',
                                          }}
                                          onClick={() => lwm2mFotaHandler(data)}
                                          className={
                                            fotaHandler(data) ? '' : 'text-gray-400 border-gray-300'
                                          }
                                        >
                                          {!doFota ? '수정 하기' : '변경'}
                                        </Button>
                                      </div>
                                      <Select
                                        id='fota-server'
                                        value={selectedServerId}
                                        onChange={(e) => {
                                          selectServerHandler(e.target.value)
                                        }}
                                        className={`mx-2 ${!doFota ? 'bg-gray-300' : ''}`}
                                        sx={{width: 319}}
                                        disabled={!doFota}
                                        size='small'
                                      >
                                        {serverList.map((server) => (
                                          <MenuItem key={server.id} value={server.id}>
                                            {server.label}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </div>

                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span
                                        className={
                                          'd-flex align-items-center gap-2 font-semibold text-[1.25rem]'
                                        }
                                      >
                                        <DoubleArrowIcon /> lwm2m IP
                                      </span>
                                      <TextField
                                        variant='outlined'
                                        className={'mx-2 bg-gray-300'}
                                        value={fotaData?.lwm2mIp || data?.lwm2mIp}
                                        inputProps={{
                                          readOnly: !doFota,
                                        }}
                                        size='small'
                                        autoComplete='off'
                                      />
                                    </div>

                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span
                                        className={
                                          'd-flex align-items-center gap-2 font-semibold text-[1.25rem]'
                                        }
                                      >
                                        <DoubleArrowIcon /> lwm2m Port
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={fotaData?.lwm2mPort || data?.lwm2mPort}
                                        inputProps={{
                                          readOnly: !doFota,
                                        }}
                                        size='small'
                                        autoComplete='off'
                                      />
                                    </div>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span
                                        className={
                                          'd-flex align-items-center gap-2 font-semibold text-[1.25rem]'
                                        }
                                      >
                                        <DoubleArrowIcon /> 이미지 서버 주소
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={fotaData?.imageIpPort || data?.imageIpPort}
                                        inputProps={{
                                          readOnly: !doFota,
                                        }}
                                        size='small'
                                        autoComplete='off'
                                      />
                                    </div>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span
                                        className={
                                          'd-flex align-items-center gap-2 font-semibold text-[1.25rem]'
                                        }
                                      >
                                        <DoubleArrowIcon /> 펌웨어 버전
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={fotaData?.firmwareVersion || data?.firmwareVersion}
                                        inputProps={{
                                          readOnly: !doFota,
                                        }}
                                        size='small'
                                        autoComplete='off'
                                      />
                                    </div>
                                  </div>
                                </Paper>
                              </div>
                            </div>
                          </div>
                          <div className={'col'}>
                            <div className={'row gap-3 overflow-auto max-h-[80vh]'}>
                              <div
                                id='dashboard-detail-map'
                                style={{width: '100%', height: 600}}
                                onClick={() => {
                                  showBusanInfoHandler(serverLocalName, officeInfo.value) &&
                                    window.open(
                                      `https://m.map.kakao.com/scheme/search?q=${data.addressRoad}&center=me`,
                                      '_blank'
                                    )
                                }}
                                className={`rounded-2 border-gray-400 border border-1 ${
                                  showBusanInfoHandler(serverLocalName, officeInfo.value)
                                    ? 'cursor-pointer'
                                    : ''
                                }`}
                              />
                              <div className={'text-end'}>
                                {showBusanInfoHandler(serverLocalName, officeInfo.value) && (
                                  <span className={'text-danger fw-bold text-end'}>
                                    지도를 클릭하면 카카오맵으로 이동합니다.
                                  </span>
                                )}
                              </div>
                              <div className={'h-100'}>
                                <div className={'row'}>
                                  <span className='font-semibold text-[1.25rem]'>
                                    검침 인식영역
                                  </span>
                                  <div className={'w-100 border-gray-400 border-2 rounded-2 pt-5'}>
                                    <div
                                      className={'row px-0 mx-0 justify-content-center imageCenter'}
                                    >
                                      <div>
                                        <canvas
                                          id='imageEdit'
                                          ref={canvasRef}
                                          style={{zIndex: 1000}}
                                          className={'px-0 mx-0'}
                                        />
                                      </div>
                                      <div>
                                        <Slider
                                          style={{width: 320, marginTop: 30}}
                                          defaultValue={data?.rotate}
                                          onChange={(e: any) => {
                                            const img = canvas.item(0)
                                            if (img && img.type === 'image') {
                                              img
                                                .set({
                                                  angle: e.target.value,
                                                  originX: 'center',
                                                  originY: 'center',
                                                })
                                                .setCoords()
                                              canvas.renderAll()

                                              const rect = canvas
                                                .getObjects()
                                                .find((obj: any) => obj.type === 'rect')
                                              const boundingBox = rect.getBoundingRect()
                                              const xstart = boundingBox.left
                                              const ystart = boundingBox.top
                                              const xend = boundingBox.left + boundingBox.width
                                              const yend = boundingBox.top + boundingBox.height
                                              let rotate = e.target.value
                                              setUpdateEfosImageInfo({
                                                ...updateEfosImageInfo,
                                                imei: data?.imei,
                                                xstart,
                                                ystart,
                                                xend,
                                                yend,
                                                rotate: rotate,
                                              })
                                            }
                                          }}
                                          min={-180}
                                          max={180}
                                          step={1}
                                          valueLabelDisplay='auto'
                                        />
                                      </div>
                                    </div>
                                    <div className={'my-3 text-center '}>
                                      <Button
                                        variant={'outlined'}
                                        size={'large'}
                                        className={'fs-3'}
                                        onClick={() => updateEfosImageHandler()}
                                      >
                                        수정
                                      </Button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className={'col '}>
                            <div
                              className={
                                'row mx-0 gap-2 align-self-stretch overflow-auto max-h-[80vh]'
                              }
                            >
                              <div
                                className={
                                  ' border border-1 border-gray-400 shadow-sm px-0 align-self-stretch'
                                }
                              >
                                <Paper
                                  className={
                                    'p-4 border-bottom border-1 border-gray-400 align-self-stretch '
                                  }
                                  square
                                >
                                  <span className='font-semibold text-[1.25rem]'>검침기 정보</span>
                                </Paper>
                                <Paper className={'p-4 '} square>
                                  <div className={'row gap-2'}>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span
                                        className={
                                          'd-flex align-items-center gap-2 font-semibold text-[1.25rem]'
                                        }
                                      >
                                        <DoubleArrowIcon /> 검침기 S/N
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={globalSerialNumberFormatWithHyphens(
                                          data?.meterReadSerialNumber
                                        )}
                                        inputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span
                                        className={
                                          'd-flex align-items-center gap-2 font-semibold text-[1.25rem]'
                                        }
                                      >
                                        <DoubleArrowIcon /> 계량기 통신상태
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={data?.efosStatus === true ? '정상' : '점검'}
                                        inputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span
                                        className={
                                          'd-flex align-items-center gap-2 font-semibold text-[1.25rem]'
                                        }
                                      >
                                        <DoubleArrowIcon /> 미터링 통신실패
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={
                                          data?.meterReadCommFailCount === undefined
                                            ? null
                                            : data?.meterReadCommFailCount + '회'
                                        }
                                        inputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span
                                        className={
                                          'd-flex align-items-center gap-2 font-semibold text-[1.25rem]'
                                        }
                                      >
                                        <DoubleArrowIcon /> 검침기 펌웨어
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={'YIT-EFOS'}
                                        inputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span
                                        className={
                                          'd-flex align-items-center gap-2 font-semibold text-[1.25rem]'
                                        }
                                      >
                                        <DoubleArrowIcon /> 검침기 설치일시
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={data?.meterReadInstallDate ?? ''}
                                        inputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span
                                        className={
                                          'd-flex align-items-center gap-2 font-semibold text-[1.25rem]'
                                        }
                                      >
                                        <DoubleArrowIcon /> 내구연한 ( 단위 : 년 )
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={data.remainDurability}
                                        inputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span
                                        className={
                                          'd-flex align-items-center gap-2 font-semibold text-[1.25rem]'
                                        }
                                      >
                                        <DoubleArrowIcon /> 이미지 명암
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        style={{width: 319}}
                                        className={'mx-2 '}
                                        defaultValue={data?.contrast}
                                        onChange={async (e) => {
                                          setUpdateEfosInfo({
                                            ...updateEfosInfo,
                                            contrast: e.target.value,
                                          })
                                        }}
                                        disabled={data?.deviceType === 'digital'}
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position='end'>
                                              <IconButton aria-label='resetBtn' edge='end'>
                                                <Button
                                                  variant={'outlined'}
                                                  size={'large'}
                                                  sx={{width: 50, height: 50}}
                                                  onClick={() => updateEfosInfoHandler('contrast')}
                                                  disabled={data?.deviceType === 'digital'}
                                                >
                                                  수정
                                                </Button>
                                              </IconButton>
                                            </InputAdornment>
                                          ),
                                        }}
                                      />
                                    </div>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span
                                        className={
                                          'd-flex align-items-center gap-2 font-semibold text-[1.25rem]'
                                        }
                                      >
                                        <DoubleArrowIcon />
                                        이미지 밝기
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        style={{width: 319}}
                                        className={'mx-2 '}
                                        defaultValue={data?.brightness}
                                        disabled={data?.deviceType === 'digital'}
                                        onChange={async (e) => {
                                          setUpdateEfosInfo({
                                            ...updateEfosInfo,
                                            brightness: e.target.value,
                                          })
                                        }}
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position='end'>
                                              <IconButton aria-label='resetBtn' edge='end'>
                                                <Button
                                                  variant={'outlined'}
                                                  size={'large'}
                                                  sx={{width: 50, height: 50}}
                                                  disabled={data?.deviceType === 'digital'}
                                                  onClick={() =>
                                                    updateEfosInfoHandler('brightness')
                                                  }
                                                >
                                                  수정
                                                </Button>
                                              </IconButton>
                                            </InputAdornment>
                                          ),
                                        }}
                                      />
                                    </div>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span
                                        className={
                                          'd-flex align-items-center gap-2 font-semibold text-[1.25rem]'
                                        }
                                      >
                                        <DoubleArrowIcon />
                                        이미지 회전
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={
                                          data?.rotate === undefined ? null : data.rotate + '°'
                                        }
                                        inputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span
                                        className={
                                          'd-flex align-items-center gap-2 font-semibold text-[1.25rem]'
                                        }
                                      >
                                        <DoubleArrowIcon /> 지침부 자릿수
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        style={{width: 319}}
                                        className={'mx-2 '}
                                        defaultValue={data?.digit}
                                        onChange={async (e) => {
                                          setUpdateEfosInfo({
                                            ...updateEfosInfo,
                                            digit: e.target.value,
                                          })
                                        }}
                                        disabled={data?.deviceType === 'digital'}
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position='end'>
                                              <IconButton aria-label='resetBtn' edge='end'>
                                                <Button
                                                  variant={'outlined'}
                                                  size={'large'}
                                                  sx={{width: 50, height: 50}}
                                                  disabled={data?.deviceType === 'digital'}
                                                  onClick={() => updateEfosInfoHandler('digit')}
                                                >
                                                  수정
                                                </Button>
                                              </IconButton>
                                            </InputAdornment>
                                          ),
                                        }}
                                      />
                                    </div>

                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span
                                        className={
                                          'd-flex align-items-center gap-2 font-semibold text-[1.25rem]'
                                        }
                                      >
                                        <DoubleArrowIcon /> 계량기 타입
                                      </span>
                                      <div
                                        className='d-flex align-items-center gap-3 mx-2 p-2'
                                        style={{borderRadius: '4px', border: '1px solid #ccc'}}
                                      >
                                        <FormControl variant='outlined' style={{width: 230}}>
                                          <Select
                                            id='meter-type-select'
                                            value={
                                              updateRecognizedType ||
                                              data?.recognizedType ||
                                              'analog'
                                            }
                                            onChange={(e) => {
                                              setUpdateRecognizedType(e.target.value)
                                            }}
                                          >
                                            <MenuItem value='analog'>
                                              {meterReadEnum.ANALOG}
                                            </MenuItem>
                                            <MenuItem value='digital'>
                                              {meterReadEnum.DIGITAL}
                                            </MenuItem>
                                            <MenuItem value='gas'>{meterReadEnum.GAS}</MenuItem>
                                            <MenuItem value='PRV'>{meterReadEnum.PRV}</MenuItem>
                                          </Select>
                                        </FormControl>
                                        <Button
                                          variant='outlined'
                                          size='medium'
                                          sx={{width: 50, height: 50}}
                                          onClick={() => updateRecognizedTypeHandler()}
                                        >
                                          수정
                                        </Button>
                                      </div>
                                    </div>
                                  </div>
                                </Paper>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                )}
                {selectedView === 'edit' && (
                  <div className='container mt-5'>
                    <div className='row'>
                      {/* 왼쪽: 이미지 영역 */}
                      <div className='col-lg-6 mb-4'>
                        <div className='card shadow-sm'>
                          <div className='card-body'>
                            <div className='flex align-center justify-content-center'>
                              <span className='font-semibold text-[1.25rem] text-center'>
                                원본 이미지
                              </span>
                              <CustomWidthTooltip
                                title={DeviceEditImageTooltip('original')}
                                TransitionComponent={Fade}
                                TransitionProps={{timeout: 600}}
                                placement={'right-start'}
                                arrow={true}
                                sx={{fontSize: '10px', letterSpacing: '1px', cursor: 'pointer'}}
                              >
                                <HelpIcon
                                  color={'primary'}
                                  sx={{fontSize: '24px'}}
                                  className={'ms-4 mb-2 cursor-pointer'}
                                />
                              </CustomWidthTooltip>
                            </div>
                            <canvas
                              ref={baseCanvasRef}
                              width={400}
                              height={300}
                              className='border border-secondary w-100 mb-3'
                              onMouseDown={startDrawing}
                              onMouseMove={draw}
                              onMouseUp={stopDrawing}
                              onMouseLeave={stopDrawing}
                              style={{
                                cursor: 'crosshair', // 커서를 페인트 브러쉬 스타일로 설정
                              }}
                            />

                            <div className='flex align-center justify-content-center'>
                              <span className='font-semibold text-[1.25rem] text-center'>
                                레이어
                              </span>
                              <CustomWidthTooltip
                                title={DeviceEditImageTooltip('overLay')}
                                TransitionComponent={Fade}
                                TransitionProps={{timeout: 600}}
                                placement={'right-start'}
                                arrow={true}
                                sx={{fontSize: '10px', letterSpacing: '1px', cursor: 'pointer'}}
                              >
                                <HelpIcon
                                  color={'primary'}
                                  sx={{fontSize: '24px'}}
                                  className={'ms-4 mb-2 cursor-pointer'}
                                />
                              </CustomWidthTooltip>
                            </div>
                            <canvas
                              ref={overlayCanvasRef}
                              width={400}
                              height={300}
                              className='border border-secondary w-100 mb-3'
                            />
                            <div className='flex align-center justify-content-center'>
                              <span className='font-semibold text-[1.25rem] text-center'>필터</span>
                              <CustomWidthTooltip
                                title={DeviceEditImageTooltip('filter')}
                                TransitionComponent={Fade}
                                TransitionProps={{timeout: 600}}
                                placement={'right-start'}
                                arrow={true}
                                sx={{fontSize: '10px', letterSpacing: '1px', cursor: 'pointer'}}
                              >
                                <HelpIcon
                                  color={'primary'}
                                  sx={{fontSize: '24px'}}
                                  className={'ms-4 mb-2 cursor-pointer'}
                                />
                              </CustomWidthTooltip>
                            </div>
                            <div className='position-relative'>
                              <canvas
                                ref={openCVCanvasRef}
                                width={400}
                                height={300}
                                className='border border-secondary w-100'
                              />
                              {/* 워커가 7.9MB 라이브러리를 읽는 동안에는 보정이 걸리지 않는다.
                                  멈춘 게 아니라는 것, 실패했다면 실패했다는 것을 알린다. */}
                              {(!cvReady || cvFailed) && (
                                <div
                                  className='position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center'
                                  style={{backgroundColor: 'rgba(255, 255, 255, 0.85)'}}
                                >
                                  {cvFailed ? (
                                    <span
                                      className='text-danger text-center px-3'
                                      style={{fontSize: '12px'}}
                                    >
                                      이미지 필터를 불러오지 못했습니다.
                                      <br />
                                      아래 보이는 것은 보정 전 원본입니다.
                                    </span>
                                  ) : (
                                    <>
                                      <CircularProgress size={28} />
                                      <span className='mt-2 text-muted' style={{fontSize: '12px'}}>
                                        이미지 필터 준비 중…
                                      </span>
                                    </>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* 오른쪽: 설정 영역 */}
                      <div className='col-lg-6'>
                        <div className='card shadow-sm'>
                          <div className='card-body'>
                            <div className='flex align-center justify-content-center'>
                              <span className='font-semibold text-[1.25rem] text-center'>
                                최종 결과 이미지 예상
                              </span>
                              <CustomWidthTooltip
                                title={DeviceEditImageTooltip('final')}
                                TransitionComponent={Fade}
                                TransitionProps={{timeout: 600}}
                                placement={'right-start'}
                                arrow={true}
                                sx={{fontSize: '10px', letterSpacing: '1px', cursor: 'pointer'}}
                              >
                                <HelpIcon
                                  color={'primary'}
                                  sx={{fontSize: '24px'}}
                                  className={'ms-4 mb-2 cursor-pointer'}
                                />
                              </CustomWidthTooltip>
                            </div>
                            <canvas
                              ref={resultCanvasRef}
                              width={400}
                              height={300}
                              className='border border-secondary w-100'
                            />

                            <div className='flex align-center justify-center m-2'>
                              <span className='font-semibold text-[1.25rem] text-center items-center'>
                                레이어 설정
                              </span>
                            </div>

                            <div className='d-flex card-body shadow-sm gap-6 align-items-center justify-content-center flex-row mb-4'>
                              {/*overLay */}
                              <div className='d-flex align-items-center gap-3'>
                                <button
                                  className={`btn ${
                                    isRectangleMode ? 'btn-danger' : 'btn-primary'
                                  } btn-sm`}
                                  style={{whiteSpace: 'nowrap'}} // 줄바꿈 방지
                                  onClick={() => setIsRectangleMode(!isRectangleMode)}
                                >
                                  {isRectangleMode ? '사각형 모드 해제' : '사각형 모드'}
                                </button>

                                <label
                                  className='form-label mb-0 fw-bold'
                                  style={{
                                    fontSize: '16px',
                                    whiteSpace: 'nowrap', // 줄바꿈 방지
                                  }}
                                >
                                  색상:
                                </label>
                                <input
                                  type='color'
                                  value={overLayLine?.lineColor}
                                  onChange={(e) =>
                                    changeOverLayLineHandler('lineColor', e.target.value)
                                  }
                                  className='form-control form-control-color'
                                  style={{width: '70px'}}
                                />
                              </div>

                              <div className='d-flex align-items-center gap-3'>
                                <label
                                  className='form-label mb-0'
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '18px',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  선 굵기:
                                </label>
                                <input
                                  type='range'
                                  min='1'
                                  max='20'
                                  value={overLayLine?.lineWidth}
                                  onChange={(e) =>
                                    changeOverLayLineHandler('lineWidth', parseInt(e.target.value))
                                  }
                                  className='form-range'
                                  style={{width: '100%'}}
                                />
                              </div>
                            </div>
                            <div className='flex align-center justify-center m-2'>
                              <span className='font-semibold text-[1.25rem] text-center items-center'>
                                필터 설정
                              </span>
                            </div>
                            <div className='card-body shadow-sm gap-6 align-items-center justify-content-center  mb-4'>
                              <div className='mb-3'>
                                <label
                                  className='form-label'
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '18px',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  블러: {imageFilter?.blur}
                                </label>
                                <input
                                  type='range'
                                  min='0'
                                  max='50'
                                  step='1'
                                  value={imageFilter?.blur}
                                  onChange={(e) =>
                                    changeImageFilter('blur', parseInt(e.target.value))
                                  }
                                  className='form-range'
                                />
                              </div>
                              <div className='mb-3'>
                                <label
                                  className='form-label'
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '18px',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  샤프닝: {imageFilter?.sharpening}
                                </label>
                                <input
                                  type='range'
                                  min='0'
                                  max='10'
                                  step='0.1'
                                  value={imageFilter?.sharpening}
                                  onChange={(e) =>
                                    changeImageFilter('sharpening', parseFloat(e.target.value))
                                  }
                                  className='form-range'
                                />
                              </div>
                              <div className='mb-3'>
                                <label
                                  className='form-label'
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '18px',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  명암: {imageFilter?.contrast}
                                </label>
                                <input
                                  type='range'
                                  min='0.5'
                                  max='3'
                                  step='0.1'
                                  value={imageFilter?.contrast}
                                  onChange={(e) =>
                                    changeImageFilter('contrast', parseFloat(e.target.value))
                                  }
                                  className='form-range'
                                />
                              </div>
                              <div className='mb-3'>
                                <label
                                  className='form-label'
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '18px',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  밝기: {imageFilter?.brightness}
                                </label>
                                <input
                                  type='range'
                                  min='0'
                                  max='2'
                                  step='0.1'
                                  value={imageFilter?.brightness}
                                  onChange={(e) =>
                                    changeImageFilter('brightness', parseFloat(e.target.value))
                                  }
                                  className='form-range'
                                />
                              </div>
                              <div className='mb-3'>
                                <label
                                  className='form-label'
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '18px',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  감마: {imageFilter?.gamma}
                                </label>
                                <input
                                  type='range'
                                  min='0.1'
                                  max='3'
                                  step='0.1'
                                  value={imageFilter?.gamma}
                                  onChange={(e) =>
                                    changeImageFilter('gamma', parseFloat(e.target.value))
                                  }
                                  className='form-range'
                                />
                              </div>
                            </div>
                            <div className='d-flex justify-content-between'>
                              <button onClick={deleteImageRevisionData} className='btn btn-info'>
                                보정 이미지 삭제
                              </button>
                              <button onClick={clearCanvasHandler} className='btn btn-danger'>
                                레이어 지우기
                              </button>
                              <button onClick={resetImageFilter} className='btn btn-warning'>
                                필터 초기화
                              </button>
                              <button onClick={saveFilterSetting} className='btn btn-primary'>
                                저장
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      </Box>
    </Modal>
  )
}
export default DeviceDetailInfoModal
